import React from 'react';
import { ReactSVG } from "react-svg";
import i18n from '../../i18n/i18n.js';
import { Link  } from "react-router-dom";

import './LoyaltyClub.css';

class LoyaltyClub extends React.Component {

  constructor(props) {
      super(props);
  }

  render() {
    const signed = window.AppRef.current.get_is_signed();

    return (<div className="loyalty_club">
        
        <ReactSVG className="icon" src={`assets/images/logo_black.svg`} />
        <h3>{i18n.t("loyaltyClubTitle")}</h3>
        <div className="text">{i18n.t("loyaltyClubText")}</div>
  
        {<button className="button" onClick={() => { signed ? window.modals['ProfileMenuRef'].current.show() && window.modals['RoyaltyCardRef'].current.show() : (window.location.href='/welcome') }}>{i18n.t("loyaltyClubRegistration")}</button>}
    </div>);
  }
}

export default LoyaltyClub;

